import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

//alerta
import Table from "../../components/Table";
import { Box } from "@material-ui/core";
import { Block, Check, HourglassEmpty } from "@mui/icons-material";

const data = [
  {
    ID_Operacao: "c947538d",
    Usuario: "Amanda Marlene Carrara Domingues",
    IP: "244.206.97.23",
    Data_Hora: "09/07/2024 14:25",
    Modulo: "Dashboard",
    Operacao: "Atualização",
    Status: "Sucesso",
  },
  {
    ID_Operacao: "f1fd1c0a",
    Usuario: "Amanda Marlene Carrara Domingues",
    IP: "244.206.97.23",
    Data_Hora: "09/07/2024 14:21",
    Modulo: "Ocorrências",
    Operacao: "Atualização",
    Status: "Falha",
  },
  {
    ID_Operacao: "6530d23f",
    Usuario: "Amanda Marlene Carrara Domingues",
    IP: "244.206.97.23",
    Data_Hora: "09/07/2024 14:20",
    Modulo: "Ocorrências",
    Operacao: "Atualização",
    Status: "Falha",
  },
  {
    ID_Operacao: "a5522d26",
    Usuario: "Amanda Marlene Carrara Domingues",
    IP: "244.206.97.23",
    Data_Hora: "09/07/2024 14:15",
    Modulo: "Ocorrências",
    Operacao: "Leitura",
    Status: "Sucesso",
  },
  {
    ID_Operacao: "d604fc85",
    Usuario: "Arthur Nilo de Assunção Neto",
    IP: "244.206.97.97",
    Data_Hora: "09/07/2024 14:08",
    Modulo: "Dashboard",
    Operacao: "Leitura",
    Status: "Sucesso",
  },
  {
    ID_Operacao: "a84b2133",
    Usuario: "Arthur Nilo de Assunção Neto",
    IP: "244.206.97.97",
    Data_Hora: "09/07/2024 14:08",
    Modulo: "Relatório",
    Operacao: "Criação",
    Status: "Pendente",
  },
  {
    ID_Operacao: "45e42a41",
    Usuario: "Arthur Nilo de Assunção Neto",
    IP: "244.206.97.97",
    Data_Hora: "09/07/2024 14:05",
    Modulo: "Ocorrências",
    Operacao: "Leitura",
    Status: "Sucesso",
  },
  {
    ID_Operacao: "25298331",
    Usuario: "Guilherme Jair Aragão Neto",
    IP: "244.206.97.99",
    Data_Hora: "09/07/2024 14:03",
    Modulo: "Relatório",
    Operacao: "Atualização",
    Status: "Sucesso",
  },
];

function StatusComponent({ row }) {
  return (
    <Box
      sx={{
        maxWidth: "120px",
        padding: "4px 8px",
        backgroundColor:
          row.original.Status === "Sucesso"
            ? "#216e1f"
            : row.original.Status === "Pendente"
            ? "#947100"
            : "#b50909",
        borderRadius: "4px",
        color: "white",
      }}
    >
      {row.original.Status === "Sucesso" && <Check size={12} />}
      {row.original.Status === "Pendente" && <HourglassEmpty size={12} />}
      {row.original.Status === "Falha" && <Block size={12} />}
      <span style={{ marginLeft: 10 }}>{row.original.Status}</span>
    </Box>
  );
}

export default function UserList() {
  // Permissão do usuário no sistema
  let userPermission;
  switch (localStorage.getItem("Permission")) {
    case "Admin":
      userPermission = "admin";
      break;
    case "Controlador":
      userPermission = "manager";
      break;
    case "Executor":
      userPermission = "executor";
      break;
    default:
      break;
  }

  const navigate = useNavigate();

  // States
  const [refresh, setRefresh] = useState(true);

  // useEffect
  useEffect(() => {
    // if (refresh === true) {
    //   api
    //     .get(
    //       `${userPermission}/users?filter={"where":{"or":[{"role":"Admin"}, {"role":"Controlador"}, {"role":"Executor"}]}}`
    //     )
    //     .then((response) => {
    //       setUsers(response.data);
    //     });
    // }
    // setRefresh(false);
    // pega todos os usuários cadastrados
  }, [refresh]);

  /* Colunas da tabela */
  const columns = useMemo(
    () => [
      {
        Header: "ID Operação",
        accessor: "ID_Operacao",
      },
      {
        Header: "Usuário",
        accessor: "Usuario",
      },
      {
        Header: "IP",
        accessor: "IP",
      },
      {
        Header: "Data e Hora",
        accessor: "Data_Hora",
      },
      {
        Header: "Módulo",
        accessor: "Modulo",
      },
      {
        Header: "Operação",
        accessor: "Operacao",
      },
      {
        Header: "Status",
        Cell: StatusComponent,
      },
    ],
    []
  );

  return (
    <div>
      <Table
        columns={columns}
        data={data}
        searchBy="Usuario"
        label="Pesquise um usuário pelo e-mail"
      />
    </div>
  );
}
